module.exports = __webpack_public_path__ + "images/admin/teams-banner-icon.png";